import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ClientReview.css';

const ClientReview = () => {
    const [reviewText, setReviewText] = useState('');
    const [username, setUsername] = useState('');
    const [rating, setRating] = useState(0);

    const handleSubmit = (event) => {
        event.preventDefault();
        axios.post('https://drusillakhulwael-backend.vercel.app/add-review', { reviewText, username, rating })
            .then(response => {
                toast.success('Thank you! Your review was submitted successfully.');
                setReviewText('');
                setUsername('');
                setRating(0);
            })
            .catch(error => {
                toast.error('An error occurred while submitting your review. Please try again.');
                console.error('An error occurred:', error);
            });
    };

    return (
        <div className='clientReview'>
            <form onSubmit={handleSubmit}>
                <h4>Please Leave a Review!</h4>
                <div>
                    <label>Your Name:</label>
                    <input 
                        className='name-input'
                        type='text'
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </div>
                <div>
                    <label>Review:</label>
                    <textarea
                        value={reviewText}
                        onChange={(e) => setReviewText(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Rating:</label>
                    {[1, 2, 3, 4, 5].map((star) => (
                        <span key={star}>
                            <input
                                type="radio"
                                value={star}
                                checked={rating === star}
                                onChange={(e) => setRating(parseInt(e.target.value))}
                            />
                            {star} 
                        </span>
                    ))}
                </div>
                <button type="submit">Submit Review</button>
                <Link to="/">Click to go Back to Home</Link>
            </form>
            {/* Toast Container */}
            <ToastContainer />
        </div>
    );
};

export default ClientReview;
